// frontend/src/utils/auth.js
import api from "./axios";

export const checkAuth = async () => {
  try {
    const response = await api.get("/auth/me"); // Need to create this endpoint
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      // Clear localStorage and redirect to login
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    throw error;
  }
};

export const getUserFromSession = async () => {
  try {
    // First, check if we have a valid session
    const response = await api.get("/auth/check-session");
    if (response.data.authenticated) {
      // Store user in localStorage
      localStorage.setItem("user", JSON.stringify(response.data.user));
      return response.data.user;
    }
    return null;
  } catch (error) {
    console.error("Session check failed:", error);
    localStorage.removeItem("user");
    return null;
  }
};
